import { render, staticRenderFns } from "./coupGiveList.vue?vue&type=template&id=0a6451ae&"
import script from "./coupGiveList.vue?vue&type=script&lang=js&"
export * from "./coupGiveList.vue?vue&type=script&lang=js&"
import style0 from "./coupGiveList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports